(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glossary-directory"] && !Shopify.designMode) return;
  try {
    
class GlossaryDirectory extends HTMLElement {
  connectedCallback() {
    this.entries = Array.from(this.querySelectorAll('[data-glossary-entry]'));
    this.groups = Array.from(this.querySelectorAll('[data-glossary-group]'));
    this.countEl = this.querySelector('[data-glossary-count]');
    this.emptyEl = this.querySelector('[data-glossary-empty]');
    this.countTemplate = this.countEl ? this.countEl.textContent.trim() : '';
    this.query = '';
    this.category = '';

    const search = this.querySelector('[data-glossary-search]');
    if (search) {
      search.addEventListener('input', () => {
        this.query = search.value.trim().toLowerCase();
        this.apply();
      });
    }

    this.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-glossary-category]');
      if (chip) {
        this.category = chip.dataset.glossaryCategory;
        this.querySelectorAll('[data-glossary-category]').forEach((c) => {
          c.classList.toggle('is-active', c === chip);
        });
        this.apply();
        return;
      }
      if (event.target.closest('[data-glossary-reset]')) {
        this.category = '';
        this.query = '';
        if (search) search.value = '';
        this.querySelectorAll('[data-glossary-category]').forEach((c, i) => {
          c.classList.toggle('is-active', i === 0);
        });
        this.apply();
      }
    });
  }

  apply() {
    let visible = 0;
    this.entries.forEach((entry) => {
      const matchesText = !this.query || entry.dataset.term.includes(this.query);
      const matchesCat = !this.category || entry.dataset.category === this.category;
      const show = matchesText && matchesCat;
      entry.hidden = !show;
      if (show) visible += 1;
    });

    // Eine Buchstabengruppe ohne sichtbare Karte wird selbst ausgeblendet,
    // sonst bleibt eine nackte Überschrift ohne Inhalt stehen.
    this.groups.forEach((group) => {
      const any = Array.from(group.querySelectorAll('[data-glossary-entry]')).some((e) => !e.hidden);
      group.hidden = !any;
      const letter = group.dataset.glossaryGroup;
      const jump = this.querySelector('[data-glossary-jump="' + letter + '"]');
      if (jump) jump.classList.toggle('is-muted', !any);
    });

    if (this.countEl) {
      this.countEl.textContent = this.countTemplate.replace(/\d+/, visible);
    }
    if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
  }
}

if (!customElements.get('glossary-directory')) {
  customElements.define('glossary-directory', GlossaryDirectory);
}

  } catch(e) { console.error(e); }
})();
})();
